module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("LORD HAROLD")]), _vm._v(" Bast fronça les sourcils à la vue des nombreux courriers sur son bureau.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi tout le monde pense-t-il que je sais qui est ce mystérieux mage ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian ajouta les chiffres des factures et ignora son ami. Un papier chiffonné rebondit sur sa tête, ce qui lui fit lever les yeux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien sûr, tu ne sais rien au sujet de cet étrange homme capé aux capacités de guérison à Larnlyon ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Harold ôta ses lunettes et se frotta le front.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Que suis-je supposé dire au roi ? Il exige un rapport complet par miroir dans la matinée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu devrais dire au roi de compter sur son Mage de Cour au lieu de te demander de faire son sale boulot. Par ailleurs, il semblerait, d’après ce que t’a dit le Capitaine Pembrost, qu’il n’ait pas grand-chose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Comme si j’allais laisser l’un d’eux me trouver.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je dois songer à quelque chose de plus diplomatique si nous voulons que le roi cherche ailleurs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Harold agita sa main dans les airs quand Sebastian ouvrit la bouche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne suis pas idiot ! Une taverne ? Et si le prince avait été dépossédé ou s’était retrouvé sous la pluie ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Les rumeurs disent que le prince a été trouvé dans une taverne tenue par l’un des amis de Margaret, ancien Garde de la Ville. J’ai entendu dire qu’il était aussi en sécurité qu’un nouveau-né entre ses mains jusqu’à ce que les gardes du château arrivent.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Combien de temps as-tu l’intention de me mentir obstinément ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Jusqu’à ce que tu prouves le contraire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Harold lui jeta un regard noir et un autre morceau de papier vola dans les airs. Il s’arrêta à mi-chemin entre leurs bureaux, se déplia, se lissa et remonta le long du bras d’Harold pour lui gifler le visage. Harold l’arracha, ses yeux marron clair s’embrasant, quand la sonnette de la porte accueillit un autre client.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Lord Bast ? Ne faisait-il pas sombre ici l’espace d’un instant ? demanda Mr Jenkins alors qu’il passait devant les étagères en boitillant jusqu’au bureau où Sebastian et Harold étaient assis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non, il fait plus clair que jamais.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("En bon homme d’affaires, Harold adressa un sourire rayonnant au vieil homme et lui serra la main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai votre commande.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il prit deux livres liés par une ficelle dans une pile de paquets similaires sur son bureau. Davantage de salutations et de pièces furent échangées, puis ils furent à nouveau seuls.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais donner une réponse plausible au Roi Harris, mais je t’en prie, envisage de révéler la vérité. Avoir sauvé le Prince Turren pourrait mettre ta vie en danger.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il n’y a aucun témoin autre que le propriétaire de la taverne entendant une voix d’homme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian se racla la gorge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— De ce que j’ai entendu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Au moins, apprends à mieux mentir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("HAROLD PASSA")]), _vm._v(" la tête dans la chambre d’amis où Sebastian était en train de répertorier des piles de livres s’élevant jusqu’au plafond.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cadeaux, dit-il joyeusement tandis que Sebastian s’époussetait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ce dernier tendit la main et Harold lui donna une liasse de papiers. Feuilletant les pages, il vit plusieurs feuillets dépeignant un homme avec une cape. La plupart des visages étaient laissés en blanc, mais quelques-uns portaient les traits d’un monstre frappé par la lumière.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ridicule.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le texte à côté de ces illustrations grotesques attira son regard et il plissa les yeux pour le lire. Soit il était un géant de plus de deux mètres, soit il atteignait à peine un mètre. En bas de la pile, il y eut une image qui ressemblait étrangement à sa silhouette.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je pensais bien que celle-ci retiendrait ton attention. Celles aux visages de démons circulent plus vite à travers la ville, mais cette image m’inquiète, car elle est issue du château. Lord Pasley l’a dessinée lui-même, déclara Harold avec sérieux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je dois demander à Ophélia de renforcer les sortilèges sur mes capes s’il a été en mesure d’avoir une vision si nette de moi depuis l’intérieur de la taverne. Tant que cela ne parvient pas jusqu’à mon père, cela devrait aller.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je te remercie d’avoir finalement été honnête. Qu’en est-il du Prince Turren ? Était-il réveillé assez longtemps pour bien te regarder ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian haussa les épaules.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il était inconscient la plupart du temps, je doute qu’il se souvienne de quelque chose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— TE SOUVIENS-TU")]), _vm._v(" de quelque chose ? demanda à nouveau un Lord Pasley exaspéré.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je me souviens que ce n’était pas l’homme qui m’a poignardé, répondit le Prince Turren.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce qui ne nous dit pas s’il est votre sauveur ou un conspirateur, dit le Capitaine Pembrost sans lever les yeux de son livre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous devons le retrouver. Il m’a fallu quatre sorts pour faire une seule image, dit Lord Pasley.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Prince Turren eut un sourire narquois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Es-tu certain que ce soit au sujet de mon agression et non pas que tu veux retrouver le magicien qui t’a surpassé ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis ton médecin traitant, il est donc en mon pouvoir de te forcer à boire d’ignobles tonifiants durant ta convalescence, menaça Lord Pasley.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais bien. Mon beau sauveur m’a très bien guéri. Je suis seulement épuisé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost reposa son livre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment savez-vous qu’il est beau ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren fronça les sourcils.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je le présume. C’est ce qui arrive dans les contes de fées. Tous les princes et les princesses ont de séduisants sauveurs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Lord Pasley, laissez-nous, je vous prie, exigea le Capitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Pasley se leva.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Très bien, cependant je veux les mêmes réponses.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il se dirigea vers la porte.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Et il ne m’a pas surpassé, ajouta-t-il avant de la refermer derrière lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost adressa un regard noir à sa mission.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il est de ma responsabilité de trouver vos assaillants et Lord Pasley a raison, cet homme pourrait nous mener à eux. De quoi vous souvenez-vous que vous ne partagez pas ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Les doigts de Turren s’entrelacèrent et se posèrent sur sa poitrine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne mens pas. Je n’ai jamais vu son visage, mais je crois me souvenir de sa voix.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Poursuivez.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Elle était étrange. Pas rauque ou prononcée, cependant elle m’a laissé une impression.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Était-elle magique ? demanda Pembrost, inquiet qu’ils aient manqué un sortilège jeté sur leur prince.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non, ma réaction était… naturelle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren évita les yeux du capitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’étais surpris que mon corps soit capable de répondre, mais j’imagine que c’était parce que la voix était si fa…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Fa ? demanda le capitaine quand Turren s’interrompit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Fascinante, termina Turren.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est amusant, pendant un instant j’ai pensé que vous alliez dire "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("familière")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost tapota son livre fermé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non, je voulais vraiment dire fascinante, assura le prince.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il bâilla et étira les bras.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis désolé, mais je suis trop fatigué pour poursuivre. Cela vous dérangerait-il de revenir plus tard ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren bâilla une seconde fois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vous laisse vous reposer pour le moment. Dormez bien.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— QU’A-T-IL DIT ?")]), _vm._v(" demanda Lord Pasley quand Pembrost pénétra dans le couloir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Rien d’utile pour vous, mais ce qu’il a dit ravive mes souvenirs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je m’attendais à entendre plus que cela, dit Lord Pasley. Vous êtes trop indulgent avec lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Êtes-vous sûr que l’homme qui l’a sauvé est responsable du sort de guérison ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine leva les mains quand Lord Pasley haleta à la tirade.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Peu importe, je suis certain que vous êtes sûr, ce qui complique encore plus les choses.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pardon ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je jure de vous avoir bientôt le nom du magicien, soyez patient, promit le capitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais suivre vos agaçants conseils pour le moment si vous tenez parole.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Et maintenant, qui remet en question l’honneur de qui, Frederick ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost sourit à son ami.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai les meilleures raisons de douter de vous. Par ailleurs, dit Frederick en se penchant plus près, seule une partie de l’épuisement de Turren est feinte et c’est ce qui me préoccupe. Il est le fils de mon cousin alors, je sais qu’il se surmènera en dépit de mes avertissements de se reposer. Je lui ferai plus de tests quand il se réveillera.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pembrost posa sa main sur l’épaule de Frederick.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous voyez, vous êtes meilleur que le beau sauveur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’en ai jamais douté, Capitaine. Maintenant, allez gagner votre pain.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pembrost s’inclina.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien sûr, mon Seigneur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— PÈRE VEUT")]), _vm._v(" te voir, l’accueillit Ophélia quand il franchit le seuil.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian regarda derrière elle, soupira et se retourna. Ou tenta de le faire, car une grosse paluche l’arrêta.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce n’est pas le chemin de sa chambre, dit une voix profonde dans son dos.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oh, et Kevin est venu nous rendre visite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ophélia sourit innocemment quand Sebastian se tourna en direction de la prise ferme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi joues-tu au fils prévenant ? demanda Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin leva son autre main et révéla le dessin du visage sombre et couvert de Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne vois pas de ressembl… urrrrgh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ses mots se brouillèrent quand Kevin le secoua rudement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— D’accord, peut-être que c’est un peu plus clair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin le relâcha et il se frotta l’épaule.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Qui d’autre le sait ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Seulement Ophélia et Père.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian rabattit sa capuche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je pensais qu’il aurait personnellement envoyé un message au roi pour lui dire que j’étais le responsable.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin fronça les sourcils.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non. Il m’a traîné de force avant que quiconque puisse écouter et m’a dit de fermer ma bouche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ah, donc ce n’est pas par devoir, mais par curiosité sur les motivations de Père, devina Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin haussa les épaules.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quoi qu’il en soit…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il attrapa le coude de son frère, le soulevant pratiquement de terre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne le saurai pas tant que tu ne l’auras pas vu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian monta les escaliers en direction de la chambre de ses parents, mais aucun de ses autres frères et sœurs n’était là.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Où sont-ils tous ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Les garçons étaient trop pénibles, j’ai demandé à Diana de venir. Elle les a emmenés ramasser des herbes, ce qui m’a accordé un après-midi de paix, dit Ophélia derrière eux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin frappa une fois et ouvrit la porte.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell enleva rapidement la carte et le pendule qui se trouvaient sur la table et sur ses genoux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il est inutile de frapper si tu n’attends pas que je réponde !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il fourra les objets dans sa poche et passa ses doigts sur son crâne dégarni en sueur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne savais pas que vous aviez encore suffisamment de pouvoirs pour prédire l’avenir, dit Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce ne sont pas tes affaires. Vous pouvez partir tous les deux. Je désire parler à un seul égoïste issu de mes reins.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell les congédia avec impatience.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous avez assez de pouvoir pour prédire l’avenir, mais pas suffisamment pour contrôler magiquement trois personnes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Des yeux blancs et verts se tournèrent vers Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’ai pas donné mon accord pour une lutte sans merci, marmonna Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Moi non plus, lui chuchota Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment osez-vous provoquer un père tentant de protéger son plus jeune fils !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell jeta un regard noir à Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Les agresseurs du Prince Turren ont-ils été appréhendés ? Qui sait s’ils n’exerceront pas de représailles contre toi s’ils découvrent ton identité.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi avez-vous insisté pour que, je cache la vérité à Mère ? demanda Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Elle serait aveuglée par la possibilité d’évoluer à la cour. Elle ne comprendrait pas le danger, insista-t-il. Est-ce tout, fils et fille ingrats ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, dit Sebastian avant que son frère puisse prendre la parole.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin croisa les bras.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pour l’instant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il tourna les talons, mais fut stoppé à mi-chemin quand Lord Orwell se racla la gorge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vous ordonne à tous les deux de conserver le silence, ce qui inclut, de ne pas courir le dire à votre sœur Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— TU AURAIS")]), _vm._v(" dû l’entendre, Diana. Père mentait comme un arracheur de dents, cependant je ne sais à quel propos.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ophélia s’assit sur son lit près de Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous devons voir le sort sur sa carte, dit Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana leva les yeux au ciel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— De toute évidence. Mais si nous découvrons quoi ou qui il tentait de localiser, cela nous dira-t-il ce que nous avons besoin de savoir sans sa coopération ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Qu’en est-il d’un sortilège de vérité ? demanda Kevin, faisant passer un sac de dattes de main en main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ironiquement, les sortilèges de vérité sont des mensonges. Ils indiquent à l’esprit que vous voulez tout révéler quand vous n’en avez vraiment pas envie, alors il devrait être immunisé, expliqua Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian regarda en direction de la porte.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ils sont drôlement calmes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana leva une nouvelle fois les yeux au ciel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Une petite promenade dans la nature et ils ont râlé tout le temps. Ces bastions d’endurance ne poseront pas une jambe hors du lit avant le souper.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai dû soigner Pratchett de sa maladie galopante. Il avait atteint le orange au moment où ils sont rentrés, dit Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ça lui apprendra à être un tel imbécile, dit Kevin. Quel est notre plan ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous droguons les autres et trouvons la carte avant que Mère ne rentre à la maison, annonça Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— S’il vous plaît, n’allons pas trop loin. Nous serons ceux qui nettoieront les dégâts si tu fais cela, l’avertit Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’utiliserai un sédatif léger. Je garde mes plus mauvaises mixtures pour notre sœur aînée, Alice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana lissa ses cheveux prématurément striés de gris. Ils étaient épinglés en un chignon et tendaient sa peau, lui faisant un visage belliciste encore plus féroce.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’avoue apprécier le fait que les herbes ramassées par les garçons rempliront leurs bols ce soir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle balança ses jambes et siffla gaiement en quittant la pièce.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian secoua la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Personne n’est sain d’esprit dans cette famille.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin renifla.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Elle peut être effrayante, mais elle a toujours peur de Mère....")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sa chaise se renversa sans avertissement tandis que Diana revenait dans la chambre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle arracha sa charlotte de la commode d’Ophélia et la noua sur son chignon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je l’avais oubliée, dit-elle en jetant un regard dédaigneux à Kevin étendu au sol. Je vous verrai au dîner.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin se releva et se frotta le genou.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu l’as également insultée, pourquoi seulement moi ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je pense qu’elle a pris la déclaration de Sebastian comme un compliment, supposa Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("LORD ORWELL")]), _vm._v(" et Kraven attaquaient leur deuxième bol de soupe. Sebastian se pencha vers Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Es-tu sûre de toi ? demanda-t-il en lançant un regard significatif aux deux gloutons.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis sûre qu’ils ressemblent à des porcs, répondit Diana quand Démétrius les regarda suspicieusement. Ils peuvent manger quatre bols, ils iront bien, murmura-t-elle quand il se détourna.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Si tu le dis, ajouta Ophélia à la gauche de Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous vous entendez bien cet après-midi. De quoi parlez-vous ? demanda Kraven.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Diana manque d’herbe de fermentation et demandait si nous savions s’il en poussait dans les bois, répondit Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu as dit non, n’est-ce pas ? Parce que rien ne pousse si tard dans la saison.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kraven sourit d’un air nerveux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu veux dire cette chose bleue gluante avec des fleurs rouges et jaunes ? répliqua Pratchett.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana lui adressa un sourire rayonnant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne le savais pas. Merci de me l’avoir dit. Nous pourrons refaire un tour demain.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian secoua la tête de dépit et continua de manger son bol de ragoût de poisson, avec un peu de chance non drogué.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Quand la tête de Démétrius commença à dodeliner et se redresser brusquement, Sebastian bâilla et prétendit qu’il s’endormait lui aussi. Il posa la tête sur son bras et observa les autres tomber les uns après les autres. Quand les ronflements de son père emplirent la cuisine, il releva la tête. Ophélia, Kevin et Diana clignèrent des yeux, surveillant les autres comme il l’avait fait puis ils sautèrent sur leurs pieds. Sebastian chercha la carte dans les poches de leur père, tapotant ses flancs pour faire bonne mesure.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il ne l’a pas sur lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ophélia chuchota et une lueur pourpre apparut autour de la porte.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mère ne pourra pas entrer, je pense.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle fronça le nez.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Du moins, cela la retardera.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ne perdons pas de temps, dit Kevin en ouvrant à nouveau la voie vers l’étage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ne touche pas à la porte ! avertit Ophélia alors qu’il tendait la main vers la poignée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Est-ce que ce salaud l’a piégée ? demanda Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana passa devant lui et étendit sa main sur le bois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Un sortilège muet amplifié par un morceau d’écorce de Nule de l’autre côté. C’est un problème. Cela va me prendre du temps pour le désactiver.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merveilleux, dit Sebastian, prétendant ne pas sentir le sort de protection. Il est aussi paranoïaque que nous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce connard, grogna Diana en abaissant les mains. Il provient d’un foutu livre. J’ai besoin de plus de fournitures dans mon sac.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle descendit les escaliers en trombe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous avez changé d’avis ? leur demanda Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je veux plus que jamais savoir ce qu’il y a sur cette carte, affirma Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ils n’eurent pas longtemps à attendre le retour de Diana, mais des heures passèrent alors qu’elle trafiquait les sorts. Leur sœur regarda par-dessus son épaule en direction des escaliers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ces herbes durent de cinq à sept heures. Pourquoi vérifies-tu si personne ne monte ? demanda Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Père pourrait avoir une meilleure résistance que les autres.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le regard de Diana se déplaça à nouveau vers les escaliers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Combien de fois l’as-tu drogué ? demanda-t-il tout en regardant par-dessus sa propre épaule.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin se pencha en avant, son ombre bloquant la lumière magique d’Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous as-tu déjà drogués ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian garda la bouche fermée, car il voulait entendre la réponse à la deuxième question.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Noooon, dit Diana. Cesse de me bloquer la lumière où nous serons ici toute la nuit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu mens...")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin s’interrompit alors que la porte s’ouvrait en grinçant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Diana est une sale gosse, dit Ophélia en souriant. Nous pouvons en parler.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne t’ai jamais droguée, Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Alors je n’ai rien dit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle entra dans la chambre bras dessus bras dessous avec Diana, laissant Sebastian et Kevin derrière, secouant tous les deux la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’ai pas entendu de démenti pour nous, rouspéta Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’en attendais pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian entra dans la chambre de ses parents et ouvrit quelques boites et tiroirs que les autres n’avaient pas inspectés.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Jette-t-il quelque chose ? murmura-t-il après avoir trouvé une peau de gremlin séchée sous un étalage de bijoux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il frotta ses doigts pleins d’écailles effritées sur son pantalon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Beurk.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— La ferme. Tu n’es pas celui qui fouille les sous-vêtements de Mère, siffla Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je l’ai trouvée, annonça Ophélia en faisant pendre un sac de velours noué d’un fil d’or à ses doigts.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin tendit la main, mais elle le tint hors de portée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous avons besoin d’une clé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merde ! cria Diana. Quelque chose m’a mordu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle pointa sa baguette vers le tiroir, mais Sebastian lui attrapa la main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il sera difficile de prétendre que nous ne sommes jamais venus si tu tuais la créature qui protège les affaires de Mère.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana libéra sa main et ferma le tiroir d’un coup de pied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien. Ophélia, peux-tu sentir où est la clé ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Elle est en bas. Je pense que Père l’a.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Génial, donc nous sommes censés descendre et le fouiller alors qu’il est susceptible de se réveiller d’une minute à l’autre ? demanda Kevin. Je vais me coucher.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cesse d’être lâche. Sebastian, appela Diana en se tournant vers lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ce dernier sentit une tâche pénible venir dans sa direction, il se précipita à la porte. Une prise ferme sur son épaule le stoppa.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Wow, wow, wow, d’accord, je vais descendre, dit-il et, Kevin le relâcha.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Kevin et moi l’aiderons, dit Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi nous deux ? demanda Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Parce que je fais la plus grande partie du travail, répliqua Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Quand ils se faufilèrent dans la salle à manger, le reste des Orwell avaient toujours le visage contre la table, ou dans leurs bols. Sebastian réajusta la tête de Kraven afin qu’il ne se noie pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin fouilla les poches de leur père et les trouva vides.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Devons-nous le déshabiller ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non ! siffla Sebastian, sachant qu’il finirait par faire le sale boulot. Ophélia ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je cherche, je cherche, répondit-elle alors qu’elle examinait leur père de la tête aux pieds.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ophélia, cela ne devrait pas te prendre autant de temps, cesse de jouer les curieuses, ordonna Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Très bien, vérifie sous sa langue.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Sebastian est le plus jeune.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin recula.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu ne peux pas prendre toutes tes décisions en te basant sur qui est le plus jeune, remarqua Sebastian, qui se tenait maintenant seul puisque sa fratrie avait reculé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cela a marché pendant des années et tu es un homme recherché. Considère que c’est ton châtiment, dit Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Et si la clé était ensorcelée ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Elle ne l’est pas, promit Ophélia.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian carra les épaules, déterminé à en finir aussi vite que possible. Il inclina la tête de leur père et appuya ses doigts sur ses lèvres couvertes de bave.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ouvrirai le sac, dit-il en collant ses doigts sous une langue visqueuse et trouvant une boule de fil mouillée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Marché conclu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La bouche de Diana se tordit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Et je ne t’ennuierai pas de tout mon séjour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Aucune curiosité au monde ne m’aurait poussé à faire ce que tu viens de faire, dit Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Dépêche-toi !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ophélia rassembla ses jupons et courut dans les escaliers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("SEBASTIAN ACCROCHA")]), _vm._v(" le fil au travers du lien du sac et une ouverture apparut. Quand il passa sa main dedans, elle disparut dans l’obscurité. Il dut alors plonger son bras encore plus profondément. Ses ongles identifièrent des tasses d’argent et des chandeliers, de la soie, des bijoux taillés, des perles et quelque chose qui se froissa comme du papier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ah ah !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il sortit un rouleau de parchemin. Ils l’étalèrent sur le bureau et Sebastian dénoua le ruban qui le retenait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Montre-moi, dis-moi, mon ami, les secrets du péché de ton maître, dit Diana au-dessus de la carte et une ligne rouge apparut, partant du royaume voisin, Anerith, à Trellium, la capitale de Larnlyon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Suivait-il le prince ? demanda Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non, répondit Ophélia. Il suivait quelqu’un d’autre. Quelqu’un qui a emprunté le même chemin que le prince.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle indiqua les parties de la ligne rouge qui zigzaguaient du Lac d’Argent à la taverne où avait été trouvé le prince.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Père sait qui a attaqué Turren, dit Sebastian. Ophélia, brise la magie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quoi ? Nous pouvons en apprendre plus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Brise-la avant qu’il ou elle te sente, l’avertit Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Qu’est-ce que…, commença Ophélia, mais elle se dépêcha de rouler la carte. Mince, c’était moins une. Diana, as-tu senti cela ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui. Pas étonnant que Père ne voulait pas que nous y touchions. Ce fauteur de troubles était suffisamment puissant pour s’accrocher à Ophélia à cette distance.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana se tourna vers Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment as-tu pu le savoir alors que tu n’as pas de magie ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Père n’a pas tenu la carte très longtemps, il a dû craindre d’être pris. Il se fichait que "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("nous")]), _vm._v(" découvrions son secret.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est un bon point, dit Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle posa sa paume sur le visage de Sebastian et ferma les yeux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pas de magie, Diana, juste des spéculations. Peut-être devrais-tu vérifier Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Arrêtez, tous les deux, descendons avant que les autres ne se réveillent.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin passa entre eux et se dirigea dans le couloir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Diana fusilla Sebastian du regard et suivit Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian tint le sac ouvert et Ophélia y laissa tomber la carte, le ruban à nouveau attaché.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu pousses ta chance, dit-elle en remettant le sac dans sa cachette.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian haussa les épaules et ils fermèrent la porte derrière eux. Diana chuchota contre celle-ci, réassemblant le sortilège de protection et ils rejoignirent leur famille dans leur parodie de sommeil.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 69
// module chunks = 0